import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { refresh } from '../../services/auth.service';
import Spinner from '../../components/layout/Spinner';
import FadeIn from '../../utils/fadein';
import { FaEllipsisV, FaTimes } from 'react-icons/fa';
import { getSearchQueries, getSellerFeedback } from '../../utils/api/admin';
import { Star, StarHalf } from 'lucide-react';

function SellerFeedback() {
  const [loaded, setLoaded] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [pageBreakdown, setPageBreakdown] = useState([]);
  const [data, setData] = useState([]);
  const [showSaveBanner, setShowSaveBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [buyerQuery, setBuyerQuery] = useState('');
  const [sellerQuery, setSellerQuery] = useState('');
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  const baseImageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
  const screenshotUrl = process.env.REACT_APP_BASE_IMAGE_URL + 'companyscreenshots/';

  async function loadData(){
      let res = await getSellerFeedback(buyerQuery, sellerQuery);

      if (res.success){
      setData(res.data);
      setLoaded(true);

      console.log('data', res.data);
      }

      else{
        console.log('Error loading data:', res.message);
      }
    }

  useEffect(() => {
    loadData();
  }, []);

  function loadSaveBanner(){
    setShowSaveBanner(true);
    const timer = setTimeout(() => {
      setShowSaveBanner(false);
    }, 3000);
    return () => clearTimeout(timer);
  }

  const renderStarRating = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push(<Star key={i} fill="#FFD700" color="#FFD700" size={16} />);
      } else if (i === fullStars && hasHalfStar) {
        stars.push(<StarHalf key={i} fill="#FFD700" color="#FFD700" size={16} />);
      } else {
        stars.push(<Star key={i} color="#D3D3D3" size={16} />);
      }
    }
    return <div className="star-rating">{stars}</div>;
  };

  const calculateAverageRating = (item) => {
    const ratings = [
      item.professionalism,
      item.communication,
      item.timeliness,
      item.intent,
      item.accuracy
    ];
    return ratings.reduce((a, b) => a + b, 0) / ratings.length;
  };

  async function handleBuyerSearch() {
    setLoaded(false);
    await loadData();
  }

  async function handleSellerSearch() {
    setLoaded(false);
    await loadData();
  }

  return (
    <>
      <Helmet>
        <title>LeadrPro - Discover new software</title>
      </Helmet>

      <h1>Seller Feedback {`(${data.length})`}</h1>

      <div className='flex justify-between items-center mb-4'>
        <div>
          <strong>Buyer Query: </strong>
          <input type='text' className='p-2 border' value={buyerQuery} onChange={(e) => setBuyerQuery(e.target.value)} placeholder='Search by buyer name or email' />
          <button className='' onClick={() => handleBuyerSearch()}>Search</button>
        </div>

        <div>
          <strong>Seller Query: </strong>
          <input type='text' className='p-2 border' value={sellerQuery} onChange={(e) => setSellerQuery(e.target.value)} placeholder='Search by seller company name' />
          <button className='' onClick={() => handleSellerSearch()}>Search</button>
        </div>
      </div>
      {loaded===false && (
        <Spinner />
      )}

      {loaded && (
         <div>
          <table className='admindashboard__table table'>
            <thead>
              <tr>
                <th>Dates</th>
                <th>Buyer</th>
                <th>Seller Company</th>
                <th>Deal Status</th>
                <th>Ratings</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => {
                const avgRating = calculateAverageRating(item);
                return (
                  <tr key={index} className={avgRating < 2 ? 'danger-row' : ''}>
                  <td>
                    <div>
                      <div><strong>Demo:</strong> {new Date(item.demo_date).toLocaleDateString()}</div>
                      <div><strong>Feedback:</strong> {new Date(item.feedback_date).toLocaleDateString()}</div>
                    </div>
                  </td>

                  <td>
                    <div className="company-cell">
                      {item.buyer_logo && <img src={imageUrl + 'tr:di-@@companylogos@@default-buyer.png/' + item.buyer_logo} style={{maxHeight: '24px'}} />}
                      <div>
                        <div>{`${item.first_name} ${item.last_name}`}</div>
                        <div className="company-name">{item.buyer_company_name}</div>
                        <div className="buyer-details">
                          <small>Apps/day: {item.applications_per_day || 'N/A'}</small>
                          <small>TZ: {item.timezone || 'N/A'}</small>
                        </div>
                      </div>
                    </div>
                  </td>

                  <td style={{maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                    <div className="company-cell">
                      {item.seller_logo && <img src={imageUrl + 'tr:di-@@companylogos@@default-buyer.png/' + item.seller_logo} style={{maxHeight: '24px'}} />}
                      {item.seller_company_name}
                    </div>

                    <div>
                      {item.feedback_text}
                    </div>
                  </td>

                  <td>
                    <div>
                      <div>{item.moving_to_proposal ? 'Moving to Proposal' : 'No Proposal'}</div>
                      <div className="deal-value">${item.estimated_value?.toLocaleString()}</div>
                    </div>
                  </td>
                  <td>
                    <div className="ratings-cell">
                      <div className="rating-row">
                        <span className="rating-label">Prof:</span>
                        {renderStarRating(item.professionalism)}
                      </div>
                      <div className="rating-row">
                        <span className="rating-label">Comm:</span>
                        {renderStarRating(item.communication)}
                      </div>
                      <div className="rating-row">
                        <span className="rating-label">Time:</span>
                        {renderStarRating(item.timeliness)}
                      </div>
                      <div className="rating-row">
                        <span className="rating-label">Intent:</span>
                        {renderStarRating(item.intent)}
                      </div>
                      <div className="rating-row">
                        <span className="rating-label">Acc:</span>
                        {renderStarRating(item.accuracy)}
                      </div>
                    </div>
                  </td>

                </tr>
                );
              })}
            </tbody>
          </table>   
       </div>
      )}

    {showModal && (
        <>
          <div className='overlay'></div>
          <div className='modal'>
            <div className='modal__close' onClick={() => setShowModal(false)}>
              <FaTimes />
            </div>

            <h2 className='modal__h2'>Admin Note</h2>

            <div className='mt-10'>
            
            </div>
          </div>
        </>
      )}

      {showSaveBanner && (
        <FadeIn delay={150} duration={300}>
          <div className='profileinfo__saved-banner'>
            Profile updated successfully!
          </div>
        </FadeIn>
      )}
    </>
  );
}

export default SellerFeedback;